import { render, staticRenderFns } from "./yzmlogin.vue?vue&type=template&id=0753611c&scoped=true"
import script from "./yzmlogin.vue?vue&type=script&lang=js"
export * from "./yzmlogin.vue?vue&type=script&lang=js"
import style0 from "./yzmlogin.vue?vue&type=style&index=0&id=0753611c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0753611c",
  null
  
)

export default component.exports